__turbopack_context__.v({
  "error_text": "index-module-scss-module__VrH3Ua__error_text",
  "feedback_card": "index-module-scss-module__VrH3Ua__feedback_card",
  "few_review_text": "index-module-scss-module__VrH3Ua__few_review_text",
  "heading": "index-module-scss-module__VrH3Ua__heading",
  "list": "index-module-scss-module__VrH3Ua__list",
  "loader": "index-module-scss-module__VrH3Ua__loader",
  "protection-link": "index-module-scss-module__VrH3Ua__protection-link",
  "review_count_text": "index-module-scss-module__VrH3Ua__review_count_text",
  "review_head": "index-module-scss-module__VrH3Ua__review_head",
  "right_box": "index-module-scss-module__VrH3Ua__right_box",
  "rotation": "index-module-scss-module__VrH3Ua__rotation",
  "rounded_score": "index-module-scss-module__VrH3Ua__rounded_score",
  "wrapper": "index-module-scss-module__VrH3Ua__wrapper",
});
